import React from "react";
import './booking-guests.css';
import { Input, message, Spin } from "antd";
import { getGuestPlaсe } from "./booking-order-guest";
import { RrtBtnSwitch, RrtTag } from "@src/controls";
import { serverFetch } from "@src/server";

const { TextArea } = Input;

const ageLabel = (age) => {
  if (age === 1) return '1 год';
  if (age >= 2 && age <= 4) return `${age} года`;
  return `${age} лет`;
};

const guestName = (item) => item.age ? `Ребёнок, ${ageLabel(item.age)}` : 'Взрослый';

const formatPrice = (price) => {
  if (price == null || price === 0) return null;
  return `${price > 0 ? '+' : ''}${price.toLocaleString('ru-RU')} ₽`;
};

const BookingGuests = ({...props}) => {
  const { orderData, optionalServices, includedServices, tariff, setOrderData } = props;

  const orRecalc = (newOrderData) => {
    setOrderData(newOrderData);
    const data = {
      ...newOrderData,
      arrival: newOrderData.arrivalDate.format('YYYY-MM-DD'),
      departure: newOrderData.departureDate.format('YYYY-MM-DD'),
    };
    serverFetch("calc/CalcOrder", { method: "POST", bodyData: data })
      .then(data => {
        setOrderData({...newOrderData, price: data.price});
      })
      .catch(data => {
        setOrderData({...newOrderData, price: 0});
        console.log(data.userMessage);
        message.error("Тариф не может быть применен");
      })
  }

  const guestsWithSeat = (orderData.guests || []).filter(i => i.seat !== undefined);

  const onSetPit = (num, id, name) => {
    const newItems = orderData.guests.map(i => i.num === num ? {...i, pit: id, pitName: name} : i );
    orRecalc({...orderData, guests: newItems, price: null});
  }

  const onSetLech = (num, id, name) => {
    const newItems = orderData.guests.map(i => i.num === num ? {...i, lech: id, lechName: name} : i );
    orRecalc({...orderData, guests: newItems, price: null});
  }

  const onSetPitAll = (id, name) => {
    const newItems = orderData.guests.map(i => i.seat === undefined ? i : {...i, pit: id, pitName: name});
    orRecalc({...orderData, guests: newItems, price: null});
  }

  const onSetLechAll = (id, name) => {
    const newItems = orderData.guests.map(i => i.seat === undefined ? i : {...i, lech: id, lechName: name});
    orRecalc({...orderData, guests: newItems, price: null});
  }

  const divPrice = (price) => {
    if (price == null) return <Spin />
    if (price > 0) return<div className="total">Итого {price.toLocaleString('ru-RU')} ₽</div> 
    return <div className="total">Тариф не подобран</div>
  }

  const servicePit = optionalServices?.filter(i => i.vid === 5) || [];
  const serviceLech = optionalServices?.filter(i => i.vid === 7) || [];
  const canApplyAll = guestsWithSeat.length > 1;
  const hasExtras = servicePit.length > 0 || serviceLech.length > 0;

  const renderOptions = (services, selectedId, onSelect, onSelectAll, showApplyAll) => (
    <div className="booking-guest-options">
      {services.map((i) => {
        const extra = formatPrice(i.price);
        return (
          <button
            type="button"
            key={i.id}
            className={`booking-guest-option${i.id === selectedId ? ' is-selected' : ''}`}
            onClick={() => onSelect(i.id, i.name)}
          >
            <span className="booking-guest-option-mark" />
            <span className="booking-guest-option-text">
              <span className="booking-guest-option-name">{i.name}</span>
              {extra && <span className="booking-guest-option-price">{extra}</span>}
            </span>
          </button>
        );
      })}
      {showApplyAll && canApplyAll && selectedId && (
        <button
          type="button"
          className="booking-guest-apply-all"
          onClick={() => {
            const current = services.find(i => i.id === selectedId);
            if (current) onSelectAll(current.id, current.name);
          }}
        >
          Применить всем гостям
        </button>
      )}
    </div>
  );

  return <div className="booking-quests">
    <div>
      <div className="row">
        <div className="label">Тариф</div>
        <RrtBtnSwitch label={tariff?.tariffName} selected/>
      </div>
      <div className="row">{includedServices?.map(i => <RrtTag label={i.name} key={i.baseOptionalServiceId}/>)}</div>
    </div>
    {hasExtras && <div>
      <div className="row">
        <div className="label">Питание и лечение</div>
      </div>
      <div className="booking-guest-hint">Выберите питание и лечение отдельно для каждого гостя. Итоговая цена пересчитается сразу.</div>
      <div className="booking-guest-list">
        {guestsWithSeat.map((guest, idx) => (
          <div className="booking-guest-card" key={guest.num}>
            <div className="booking-guest-card-head">
              <div>
                <div className="booking-guest-card-name">Гость {guest.num}. {guestName(guest)}</div>
                <div className="booking-guest-card-place">{getGuestPlaсe(guest)}</div>
              </div>
              <div className="booking-guest-card-summary">
                {[guest.pitName, guest.lechName].filter(Boolean).join(' · ') || 'Не выбрано'}
              </div>
            </div>
            {servicePit.length > 0 && <div className="booking-guest-field">
              <div className="booking-guest-field-label">Питание</div>
              {renderOptions(servicePit, guest.pit, (id, name) => onSetPit(guest.num, id, name), onSetPitAll, idx === 0)}
            </div>}
            {serviceLech.length > 0 && <div className="booking-guest-field">
              <div className="booking-guest-field-label">Лечение</div>
              {renderOptions(serviceLech, guest.lech, (id, name) => onSetLech(guest.num, id, name), onSetLechAll, idx === 0)}
            </div>}
          </div>
        ))}
      </div>
    </div>}
    <div>
      <div className="row">
        <div className="label">Сообщение</div>
      </div>
      <TextArea 
            autoSize={{ minRows: 4}} 
            value={orderData?.extraComment} 
            onChange={(e) => setOrderData({ ...orderData, extraComment: e.target.value })}
            placeholder="Оставьте ваши пожелания по бронированию, мы постараемся их исполнить при наличии соответствующих технических и организационных возможностей"
        />
    </div>
    <div>
      <div className="row">{divPrice(orderData.price)}</div>
    </div>
  </div>
}

export default BookingGuests;
